import { Button, Input, Text } from '#atoms';
import { PrevHeaderBarThreeDotTemplate } from '#templates';
import styled from 'styled-components';
import {
  ButtonBox,
  Container,
  DataInputBox,
  DataInputWrap,
  FileInput,
  GoalBox,
  GoalCard,
  IconTextBox,
  InfoBox,
  InputArea,
  InputContainer,
  InputLabel,
  MainPhotoBox,
  MaxLength,
  TextArea,
  Title,
  Toggle,
  ToggleBox,
  ToggleButton,
  ToggleLabel,
  ToggleWrap,
  UserInfoBox
} from './styles';
import { useEffect, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { result } from 'lodash';

interface ToggleProps {
  weight: boolean;
  bodyFat: boolean;
  skeletalMuscle: boolean;
  photo: boolean;
}
interface ToggleLabelProps {
  weight: string;
  bodyFat: string;
  skeletalMuscle: string;
  photo: string;
}
export const PortfolioLoad = () => {
  const [isToggleOn, setIsToggleOn] = useState<ToggleProps>({
    weight: false,
    bodyFat: false,
    skeletalMuscle: false,
    photo: false
  });

  const [trueToggles, setTrueToggles] = useState(
    Object.keys(isToggleOn).filter(
      key => isToggleOn[key as keyof ToggleProps] === true
    )
  );

  const [falseToggles, setFalseToggles] = useState(
    Object.keys(isToggleOn).filter(
      key => isToggleOn[key as keyof ToggleProps] === false
    )
  );

  const toggleLabels: ToggleLabelProps = {
    weight: '데이터 변화',
    bodyFat: '눈바디 변화',
    skeletalMuscle: '운동차트',
    photo: '수업사진'
  };

  const setToggleData = () => {
    setTrueToggles(
      Object.keys(isToggleOn).filter(
        key => isToggleOn[key as keyof ToggleProps] === true
      )
    );
    setFalseToggles(
      Object.keys(isToggleOn).filter(
        key => isToggleOn[key as keyof ToggleProps] === false
      )
    );
  };

  const onDragEnd = (result: any) => {
    const { source, destination } = result;
    if (!destination) return;

    const reorderedData = trueToggles;
    const [removed] = reorderedData.splice(source.index, 1);
    reorderedData.splice(destination.index, 0, removed);

    setTrueToggles(reorderedData);
  };

  const fileInputRef = useRef<HTMLInputElement>(null);

  // 버튼을 클릭하면 파일 입력을 트리거합니다
  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // input type="file" 요소 클릭
    }
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // onFileSelect(event.target.files);
  };

  useEffect(() => {
    setToggleData();
  }, [isToggleOn]);
  return (
    <PrevHeaderBarThreeDotTemplate dotComponent>
      <Container>
        <MainPhotoBox onClick={handleClick}>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M19.5 13H13.5V19H11.5V13H5.5V11H11.5V5H13.5V11H19.5V13Z"
                fill="#5C576B"
              />
            </svg>
            <Text>
              트레이닝 성과 표지 사진을
              <br />
              설정해 주세요
            </Text>
          </div>
          <FileInput
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
        </MainPhotoBox>
        <InputContainer>
          <Title placeholder="트레이닝 성과 제목 입력"></Title>
          <InfoBox>
            <GoalBox>
              <GoalCard>
                <Text>목표</Text>
                <IconTextBox>
                  <img src="" width={18} height={18} />
                  <Text>바디프로필</Text>
                </IconTextBox>
              </GoalCard>
              <GoalCard>
                <Text>기간</Text>
                <Text>8주</Text>
              </GoalCard>
              <GoalCard>
                <Text>횟수</Text>
                <Text>16회</Text>
              </GoalCard>
            </GoalBox>
            <UserInfoBox>
              <div>
                <span>회원 정보</span>
                <p>29세 · 남성</p>
              </div>
              <div>
                <span>수업 기간</span>
                <p>2023.11.20 ~ 2023.12.19</p>
              </div>
            </UserInfoBox>
          </InfoBox>
          <InputArea>
            <InputLabel>트레이닝 성과 소개</InputLabel>
            <TextArea
              placeholder="트레이닝 성과 소개글을 작성해 주세요."
              maxLength={1000}
            ></TextArea>
            <MaxLength>최대 1000자</MaxLength>
          </InputArea>
          <Text style={{ fontSize: '2.4rem' }}>컨텐츠 설정</Text>
          <DataInputWrap>
            <DragDropContext onDragEnd={result => onDragEnd(result)}>
              <Droppable droppableId="droppable">
                {provided => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={{
                      display: 'flex',
                      gap: '1rem',
                      flexDirection: 'column',
                      height:
                        trueToggles.length * 5.5 +
                        (trueToggles.length - 1) +
                        'rem'
                    }}
                  >
                    {trueToggles.map((key, idx) => (
                      <Draggable key={key} draggableId={key} index={idx}>
                        {provided => (
                          <DataInputBox
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style
                            }}
                          >
                            {/* <DataInputBox key={key}> */}
                            <ToggleBox>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M2 16V18H22V16H2ZM2 11V13H22V11H2ZM2 6V8H22V6H2Z"
                                  fill="#5C576B"
                                />
                              </svg>
                              <ToggleLabel>
                                {toggleLabels[key as keyof ToggleLabelProps]}
                              </ToggleLabel>
                              <ToggleWrap
                                onClick={() =>
                                  setIsToggleOn({
                                    ...isToggleOn,
                                    [key]: !isToggleOn[key as keyof ToggleProps]
                                  })
                                }
                              >
                                <Toggle
                                  isToggleOn={
                                    isToggleOn[key as keyof ToggleProps]
                                  }
                                >
                                  <ToggleButton
                                    isToggleOn={
                                      isToggleOn[key as keyof ToggleProps]
                                    }
                                  ></ToggleButton>
                                </Toggle>
                              </ToggleWrap>
                            </ToggleBox>
                            {/* </DataInputBox> */}
                          </DataInputBox>
                        )}
                      </Draggable>
                    ))}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            <div className="line"></div>
            {falseToggles.map(key => (
              <DataInputBox key={key}>
                <ToggleBox>
                  <ToggleLabel>
                    {toggleLabels[key as keyof ToggleLabelProps]}
                  </ToggleLabel>
                  <ToggleWrap
                    onClick={() =>
                      setIsToggleOn({
                        ...isToggleOn,
                        [key]: !isToggleOn[key as keyof ToggleProps]
                      })
                    }
                  >
                    <Toggle isToggleOn={isToggleOn[key as keyof ToggleProps]}>
                      <ToggleButton
                        isToggleOn={isToggleOn[key as keyof ToggleProps]}
                      ></ToggleButton>
                    </Toggle>
                  </ToggleWrap>
                </ToggleBox>
              </DataInputBox>
            ))}
          </DataInputWrap>
          <ButtonBox>
            <Button background="anti">미리보기</Button>
            <Button>생성하기</Button>
          </ButtonBox>
        </InputContainer>
      </Container>
    </PrevHeaderBarThreeDotTemplate>
  );
};
